import { AuthGate } from './components/AuthGate';
import { ConfirmProvider } from './components/Confirm';
import { Shell } from './components/Shell';
import { ToastProvider } from './components/Toast';
import { MobileShell } from './components/mobile/MobileShell';

const IS_MOBILE = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;

export function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <AuthGate>
          {(user, onLogout, onUserChange) =>
            IS_MOBILE ? (
              <MobileShell user={user} onLogout={() => void onLogout()} />
            ) : (
              <Shell user={user} onLogout={() => void onLogout()} onUserChange={onUserChange} />
            )
          }
        </AuthGate>
      </ConfirmProvider>
    </ToastProvider>
  );
}
